export default __webpack_public_path__ + "static/media/logo-anniversary.53d188ae.png";